import { Box, Skeleton, TextField } from "@mui/material";
import styles from "../index.module.scss";

const FormInput = (props: any) => {
  return (
    <>
      {props?.element?.loading && (
        <Box>
          <Skeleton
            className={`${styles.form_input} ${styles.form_select_skeleton}`}
          />
        </Box>
      )}
      {!props?.element?.loading && (
        <TextField
          placeholder={props?.element?.placeholder}
          className={styles.form_input}
          inputProps={{
            className: styles.textField_input,
          }}
          // required={true}
          // error={true}
          // helperText="First Name required"
          defaultValue={props?.element?.defaultValue}
          value={props?.element?.value}
          type={props?.element?.type === "number" ? "number" : "text"}
          onChange={(e) => {
            props?.element?.onChange(e.target.value);
          }}
          disabled={props?.element?.disabled ? true : false}
        />
      )}
    </>
  );
};

export default FormInput;
